import { render } from "./UiSelectTree.vue?vue&type=template&id=6991de98&scoped=true&ts=true"
import script from "./UiSelectTree.vue?vue&type=script&lang=ts"
export * from "./UiSelectTree.vue?vue&type=script&lang=ts"

import "./UiSelectTree.vue?vue&type=style&index=0&id=6991de98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6991de98"]])

export default __exports__